import { render } from "./vunitnums.vue?vue&type=template&id=992c5834&scoped=true"
import script from "./vunitnums.vue?vue&type=script&lang=js"
export * from "./vunitnums.vue?vue&type=script&lang=js"

import "./vunitnums.vue?vue&type=style&index=0&id=992c5834&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-992c5834"]])

export default __exports__